export default "__VITE_ASSET__Dci7H9w0__"